const recruit = [
  {
    path: '/recruit-offer',
    name: 'AcceptOffer',
    component: () => import('@/views/wxapp/recruit/accept-offer.vue'),
    meta: {
      title: '入职确认'
    }
  },
  {
    path: '/accept-success',
    name: 'AcceptSuccess',
    component: () => import('@/views/wxapp/recruit/accept-success.vue'),
    meta: {
      title: '入职确认'
    }
  },
  {
    path: '/accept-error',
    name: 'AcceptError',
    component: () => import('@/views/wxapp/recruit/accept-error.vue'),
    meta: {
      title: '基础信息填写'
    }
  },
  {
    path: '/accept-acceptance',
    name: 'AcceptAcceptance',
    component: () => import('@/views/wxapp/recruit/accept-acceptance.vue'),
    meta: {
      title: '接受成功'
    }
  },
  {
    path: '/accept-error',
    name: 'AcceptError',
    component: () => import('@/views/wxapp/recruit/accept-error.vue'),
    meta: {
      title: '入职确认'
    }
  },
  {
    path: '/induction-info',
    name: 'InductionInfo',
    component: () => import('@/views/wxapp/recruit/induction-info.vue'),
    meta: {
      title: '入职信息'
    }
  },
  {
    path: '/entry-info-first',
    name: 'EntryInfoFirst',
    component: () => import('@/views/wxapp/recruit/entry-info-first.vue'),
    meta: {
      title: '基本信息'
    }
  },
  {
    path: '/entry-info-basic',
    name: 'EntryInfoBasic',
    component: () => import('@/views/wxapp/recruit/entry-info-first.vue'),
    meta: {
      title: '基本信息',
      isInduction: true
    }
  },
  {
    path: '/entry-info-second',
    name: 'EntryInfoSecond',
    component: () => import('@/views/wxapp/recruit/entry-info-second.vue'),
    meta: {
      title: '基本信息'
    }
  },
  {
    path: '/confirm-info',
    name: 'ConfirmInfo',
    component: () => import('@/views/wxapp/recruit/confirm-info.vue'),
    meta: {
      title: '确认入职信息'
    }
  },
  {
    path: '/induction-info',
    name: 'InductionInfo',
    component: () => import('@/views/wxapp/recruit/induction-info.vue'),
    meta: {
      title: '入职信息'
    }
  },
  {
    path: '/enrollment-index',
    name: 'EnrollmentIndex',
    component: () => import('@/views/wxapp/recruit/enrollment-index.vue'),
    meta: {
      title: ''
    }
  }
]
export default recruit
